import React, {MouseEventHandler, useEffect, useRef, useState} from 'react';
import styles from './progress-bar.module.scss';
import {PLAYERSTATUS} from "@/constants";

type Props = {
    player: HTMLAudioElement | undefined,
    currentTime: string,
    totalTime: string,
    playerStatus: string,
    setPlayerStatus: (s: string) => void
};

const ProgressBar: React.FC<Props> = ({ playerStatus, setPlayerStatus, player, currentTime, totalTime }) => {
    const [measureMoves, setMeasureMoves] = useState<boolean>(false);
    const progressBarRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const changeIfMeasuring = (e: MouseEvent) => {
            if(measureMoves && player && player.duration) {
                const currentPosition = e.pageX;
                const pd = progressBarRef.current as HTMLDivElement;
                const maxPosition = pd.offsetWidth + pd.offsetLeft;
                const minPosition = pd.offsetLeft;
                if(currentPosition >= maxPosition)
                    player.currentTime = player.duration;
                else {
                    if(currentPosition <= minPosition)
                        player.currentTime = 0;
                    else {
                        player.currentTime = player.duration * ((currentPosition - pd.offsetLeft) / pd.offsetWidth);
                    }
                }
            }
        };

        const disableMeasuring = (e: any) => {
            changeIfMeasuring(e);
            setMeasureMoves(false);
            const body = document.body;
            body.removeAttribute('style');
            if(playerStatus === PLAYERSTATUS.TEMP_PAUSE) {
                try {
                    player?.play();
                    setPlayerStatus(PLAYERSTATUS.PLAYING);
                } catch(e) { console.log(e); }
            }
        };

        window.addEventListener('mousedown', changeIfMeasuring);
        window.addEventListener('mousemove', changeIfMeasuring);
        window.addEventListener('mouseup', disableMeasuring);
        return () => {
            window.removeEventListener('mousedown', changeIfMeasuring);
            window.removeEventListener('mousemove', changeIfMeasuring);
            window.removeEventListener('mouseup', disableMeasuring);
        }
    });

    const mouseDown = (e: any) => {
        setMeasureMoves(true);
        const body = document.body;
        body.style.userSelect = 'none';
        body.style.cursor = 'pointer';
        if(playerStatus === PLAYERSTATUS.PLAYING) {
            setPlayerStatus(PLAYERSTATUS.TEMP_PAUSE);
            player?.pause();
        }
    };

    return (
        <div className={styles.progressInfo}>
            <div className={styles.currentTime}>{currentTime}</div>
            <div className={styles.progressBar} ref={progressBarRef} onMouseDown={mouseDown}>
                {Array.from(Array(player?.buffered.length).keys()).map(i => {
                    if(!progressBarRef.current || !player)
                        return null;
                    const left = (progressBarRef.current.offsetWidth * (player.buffered.start(i) / player.duration));
                    const width = (progressBarRef.current.offsetWidth * (player.buffered.end(i) / player.duration) - left);
                    return (<div className={styles.buffer} key={'prg' + i} style={{left: left + 'px', width: width + 'px'}} />);
                })}
                <div className={styles.progress} style={{ width: (player ? 100 * (player.currentTime / player.duration) : 0) + '%' }} />
            </div>
            <div className={styles.totalTime}>{totalTime}</div>
        </div>
    );
}

export default ProgressBar;
